/*
 * @Author: chengyu
 * @Date: 2022-09-21 20:09:35
 * @Description: 请求方法
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getConfig } from '../config';
import { ServiceTypeEnum } from '../enums';
import { LbsCodeEnum } from '../enums/lbs';
import { createNetworkError } from '../utils/error';
import { isFunction, isObject } from '../utils/is';
import { mapError, mapInfo } from '../utils/logger';
import { sendError } from '../utils/ubt';
import initPlugins from './plugins';
function runRequest(impls, server, params) {
    var result = impls
        .map(function (fn) { var _a; return (_a = fn['onRequest']) === null || _a === void 0 ? void 0 : _a.call(fn, server, params); })
        .filter(Boolean);
    return Object.assign.apply(Object, __spreadArray([{}], result, false));
}
function runBefore(impls) {
    var result = impls.map(function (fn) { var _a; return (_a = fn['onBefore']) === null || _a === void 0 ? void 0 : _a.call(fn); }).filter(Boolean);
    return Object.assign.apply(Object, __spreadArray([{}], result, false));
}
function runSuccess(impls, data, convertResponse, convertParams) {
    var result = impls
        .map(function (fn) { var _a; return (_a = fn['onSuccess']) === null || _a === void 0 ? void 0 : _a.call(fn, data, convertResponse, convertParams); })
        .filter(Boolean);
    return Object.assign.apply(Object, __spreadArray([{}], result, false));
}
function runError(impls, e, params) {
    var result = impls.map(function (fn) { var _a; return (_a = fn['onError']) === null || _a === void 0 ? void 0 : _a.call(fn, e, params); }).filter(Boolean);
    return Object.assign.apply(Object, __spreadArray([{}], result, false));
}
/**
 * 自研服务数据格式，异常处理
 */
function helloServiceError(response) {
    var _a;
    var CODE_MAP = (_a = {},
        _a[LbsCodeEnum.ERROR] = '系统错误',
        _a[LbsCodeEnum.LACK_PARAMS] = '缺少参数',
        _a[LbsCodeEnum.INVALID_TOKEN] = 'invalid token',
        _a[LbsCodeEnum.INVALID_PARAMS] = '非法参数',
        _a);
    var data = response.data;
    if (data.code !== LbsCodeEnum.SUCCESS) {
        var result = data.data;
        var message = data.msg ||
            (result && isObject(result) ? result.info : CODE_MAP[data.code]);
        throw createNetworkError({
            message: message,
            response: response,
            fetchData: data,
        });
    }
}
function helloServiceErrorV1(response) {
    var data = response.data;
    // status 1 正确
    // status 非 1 则认为接口请求发生错误
    if (data.status !== 1) {
        var message = data.info;
        throw createNetworkError({
            message: message,
            response: response,
            fetchData: data,
        });
    }
}
function tryTransformParams(options) {
    var transformParams = options.transformParams, params = options.params;
    if (transformParams && isFunction(transformParams)) {
        return transformParams(params);
    }
    return params;
}
/**
 * - 尝试从`onBefore`生命周期中获取参数，捕获异常，防止阻塞
 *    - `Config`中的`onBefore`
 *    - `MapOptions`中的`onBefore`
 * - 获取到参数后，设置到`context`中
 * @param options
 */
function tryBefore(options) {
    return __awaiter(this, void 0, void 0, function () {
        var config, context, body, arg0, beforeResult, beforeResult, oBody, oArg0, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    // 只有`HELLO`服务需要执行，高德不需要
                    // 从`onBefore`生命周期中获取的参数，没必要传给高德服务，高德服务也感知不了
                    if (options.serviceType === ServiceTypeEnum.GAODE)
                        return [2 /*return*/];
                    config = getConfig();
                    context = options.context;
                    body = {};
                    arg0 = {};
                    if (!isFunction(config.onBefore)) return [3 /*break*/, 2];
                    return [4 /*yield*/, config.onBefore()];
                case 1:
                    beforeResult = _a.sent();
                    body = (beforeResult === null || beforeResult === void 0 ? void 0 : beforeResult.body) || {};
                    arg0 = (beforeResult === null || beforeResult === void 0 ? void 0 : beforeResult.arg0) || {};
                    _a.label = 2;
                case 2:
                    if (!isFunction(options.onBefore)) return [3 /*break*/, 4];
                    return [4 /*yield*/, options.onBefore()];
                case 3:
                    beforeResult = _a.sent();
                    oBody = (beforeResult === null || beforeResult === void 0 ? void 0 : beforeResult.body) || {};
                    oArg0 = (beforeResult === null || beforeResult === void 0 ? void 0 : beforeResult.arg0) || {};
                    body = __assign(__assign({}, body), oBody);
                    arg0 = __assign(__assign({}, arg0), oArg0);
                    _a.label = 4;
                case 4:
                    context.setBody(body);
                    context.setArg0(arg0);
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    mapError('执行外部传入onBefore异常', e_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
export function fetchWrap(server, options) {
    return __awaiter(this, void 0, void 0, function () {
        var pluginImpls, params, transformResponse, context, response, convertResult, servicePromise, flyResponse, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pluginImpls = initPlugins(options);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    transformResponse = options.transformResponse, context = options.context;
                    params = tryTransformParams(options);
                    response = runBefore(pluginImpls).response;
                    if (response) {
                        if (transformResponse && isFunction(transformResponse)) {
                            convertResult = transformResponse(response);
                            mapInfo('response cache', [convertResult]);
                            return [2 /*return*/, convertResult];
                        }
                        mapInfo('response cache', [response]);
                        return [2 /*return*/, response];
                    }
                    return [4 /*yield*/, tryBefore(options)];
                case 2:
                    _a.sent();
                    servicePromise = runRequest(pluginImpls, server, params).servicePromise;
                    if (!servicePromise) {
                        servicePromise = server(params, context);
                    }
                    return [4 /*yield*/, servicePromise];
                case 3:
                    flyResponse = _a.sent();
                    data = flyResponse.data;
                    if (transformResponse && isFunction(transformResponse)) {
                        data = transformResponse(data);
                    }
                    if (options.structureV1) {
                        // `新`数据结构，异常处理
                        helloServiceErrorV1(__assign(__assign({}, flyResponse), { data: data }));
                    }
                    else {
                        // `旧`数据结构，异常处理
                        helloServiceError(__assign(__assign({}, flyResponse), { data: data }));
                    }
                    // 请求完成时
                    runSuccess(pluginImpls, flyResponse.data, data, params);
                    // 成功回调
                    if (isFunction(options.onSuccess)) {
                        options.onSuccess(params, data);
                    }
                    mapInfo('response', [data]);
                    return [2 /*return*/, data];
                case 4:
                    error_1 = _a.sent();
                    mapError("".concat(options.serviceType), error_1);
                    // 上报错误
                    sendError(error_1);
                    // 请求报错了
                    runError(pluginImpls, error_1, params);
                    // 错误回调
                    if (isFunction(options.onError)) {
                        options.onError(error_1);
                    }
                    throw error_1;
                case 5: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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